import { useEffect, useState } from 'react'

// Tempo antes da expiração para mostrar o modal (60 segundos)
const EXPIRATION_THRESHOLD = 60 * 1000

interface TokenExpirationState {
  isExpired: boolean
  isExpiring: boolean
  timeLeft: number // em segundos
}

export const useTokenExpiration = (token: string | null): TokenExpirationState => {
  const [state, setState] = useState<TokenExpirationState>({
    isExpired: false,
    isExpiring: false,
    timeLeft: 0,
  })

  useEffect(() => {
    if (!token) {
      setState({ isExpired: true, isExpiring: false, timeLeft: 0 })
      return
    }

    const checkTokenExpiration = () => {
      try {
        // Decodificar o JWT (payload está em base64)
        const payload = JSON.parse(atob(token.split('.')[1]))
        const expirationTime = payload.exp * 1000 // converter para milliseconds
        const currentTime = Date.now()
        const timeUntilExpiration = expirationTime - currentTime

        if (timeUntilExpiration <= 0) {
          setState({ isExpired: true, isExpiring: false, timeLeft: 0 })
        } else if (timeUntilExpiration <= EXPIRATION_THRESHOLD) {
          setState({
            isExpired: false,
            isExpiring: true,
            timeLeft: Math.floor(timeUntilExpiration / 1000),
          })
        } else {
          setState({
            isExpired: false,
            isExpiring: false,
            timeLeft: Math.floor(timeUntilExpiration / 1000),
          })
        }
      } catch {
        setState({ isExpired: true, isExpiring: false, timeLeft: 0 })
      }
    }

    // Verificar imediatamente
    checkTokenExpiration()

    // Verificar a cada segundo
    const interval = setInterval(checkTokenExpiration, 1000)

    return () => clearInterval(interval)
  }, [token])

  return state
}
